import { apolloVuexListStoreFactory } from '../../../libs/ApolloVuexListStore'

import { SHIPS_QUERY } from "./graphql";

/* eslint-disable no-unused-vars */
const store = apolloVuexListStoreFactory({
  settings: {
    fetchAllQuery: SHIPS_QUERY,
    fetchAllFieldName: 'ships',
  },
  getters: {
    filterShipByShippingLine: (state, getters, rootState) => (shippingLine = null) => {
      if (shippingLine === null) {
        return state.entries;
      }

      return state.entries.filter(entry => entry.shippingLine.id === shippingLine);
    },
  }
})
/* eslint-enable no-unused-vars */

export default store

